export const parseDurationToSeconds = (
  durationStr: string
): { ok: true; duration: number } | { ok: false; error: string } => {
  const error = `Duration does not match format number[s|m|h]: "${durationStr}"`;
  const numMatch = durationStr.match(/^(?<duration>\d+)(?<unit>[a-z]*)$/i);
  const duration = numMatch?.groups?.duration;
  const unit = numMatch?.groups?.unit?.toLowerCase();

  if (duration == null || unit == null) {
    return {
      ok: false,
      error,
    };
  }
  const num = Number(duration);
  if (num < 1) {
    return {
      ok: false,
      error: `Duration must be at least 1 second: "${durationStr}"`,
    };
  }
  switch (unit) {
    case '':
    case 's':
      return { ok: true, duration: num };
    case 'm':
      return { ok: true, duration: num * 60 };
    case 'h':
      return { ok: true, duration: num * 3600 };
    default:
      return {
        ok: false,
        error,
      };
  }
};
